// extracted by mini-css-extract-plugin
export var infoItem = "_mj-1";
export var title = "_mj-0";